module.exports = __webpack_public_path__ + "img/ic_food_pizza.970013a9.png";